let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f2uOF")).then(() => parcelRequire('9uERg'));